import { lazy } from "react";
import { RouteConfig } from "../../../../../types/RouteConfig";
import { errorMembershipRoute } from "../../../../error/PageMembershipStatusError/route";

export const fireSafetyRiskAssessmentRoute: RouteConfig<'with-page'> = {
    name: 'Fire Safety Risk Assessment',
    page: lazy(() => import('.')),
    context: 'member',
    path: '/documents/company/fire-safety-risk-assessment',
    flags: ['member-route', 'no-menu-item'],
    permissions: ['companyDocuments'],
    permissionsRedirect: errorMembershipRoute,
}